var map = {
	"./DashboardAsideRoutes/index.js": 1532,
	"./DashboardHeaderRoutes/index.js": 1533,
	"./DashboardMainPanelLeftRoutes/index.js": 1534,
	"./DashboardMainPanelRightRoutes/index.js": 1535,
	"./DashboardMainRoutes/index.js": 1536,
	"./EntryRoutes/index.js": 776,
	"./SiteHeaderRoutes/index.js": 1537,
	"./SiteMainRoutes/index.js": 1538
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3318;


//////////////////
// WEBPACK FOOTER
// ./src/interface/store/routes \.\/.+\/index\.js$
// module id = 3318
// module chunks = 0